import type React from "react"
import { useFormContext } from "react-hook-form"

import { Button } from "@mui/material"

import type { ResetButtonProps } from "./reset-button.types"

export const ResetButton = ({
  disabled,
  children,
  onClick,
  variant,
  ...rest
}: ResetButtonProps) => {
  const {
    reset,
    formState: { isSubmitting },
  } = useFormContext()

  const isDisabled = disabled ?? isSubmitting

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    reset()
    if (onClick) {
      onClick(event)
    }
  }

  return (
    <Button
      {...rest}
      disabled={isDisabled}
      onClick={handleClick}
      type="button"
      variant={variant ?? "text"}
    >
      {children}
    </Button>
  )
}
